<template>
  <div>
    <md-field>
      <label>动作模板 *</label>
      <md-select v-model="form.templateId" name="template" id="form.template">
        <md-option value="OpenUI">打开UI</md-option>
        <md-option value="CloseUI">关闭UI</md-option>
        <!-- <md-option value="dkbd">打开表单</md-option> -->
        <md-option value="PlayVideo">打开视频</md-option>
        <md-option value="PlayAudio">播放音频</md-option>
        <md-option value="Delay">延时</md-option>
        <md-option value="MoveCamera">移动摄像机</md-option>
      </md-select>
    </md-field>

    <md-field v-if="form.templateId === 'OpenUI' || form.templateId === 'CloseUI'">
      <label>UI界面 *</label>
      <md-select v-model="form.uitype" name="uitype" :disabled="disabled">
        <md-option value="qr">确认界面</md-option>
        <md-option value="ts">提示界面</md-option>
      </md-select>
    </md-field>

    <md-field v-if="form.templateId === 'dkbd' || form.uitype === 'ts'">
      <label>提示内容 *</label>
      <md-input v-model="form.tipContent" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <md-field v-if="form.templateId === 'dkbd'">
      <label>表单类型 *</label>
      <md-input v-model="form.formType" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <md-field v-if="form.templateId === 'dkbd'">
      <label>表单名称 *</label>
      <md-input v-model="form.formName" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <md-field v-if="form.templateId === 'PlayVideo'">
      <label>视频名称 *</label>
      <md-input v-model="form.videoName" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <md-field v-if="form.templateId === 'PlayVideo'">
      <label>播放时长(秒) *</label>
      <md-input v-model="form.videoTime" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <md-field v-if="form.templateId === 'PlayAudio'">
      <label>音频名称 *</label>
      <md-input v-model="form.audioName" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <md-field v-if="form.templateId === 'PlayAudio'">
      <label>播放时长(秒) *</label>
      <md-input v-model="form.audioTime" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <md-field v-if="form.templateId === 'Delay'">
      <label>延时时长(秒) *</label>
      <md-input v-model="form.delayTime" type="text" :disabled="disabled"> </md-input>
    </md-field>


    <div class="md-layout" v-if="form.templateId === 'MoveCamera'">
      <div class="md-layout-item md-size-15" style="padding-left: 0px; padding-top: 20px">
        <label class="md-form-label-ext"> 位置 * </label>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label>X</label>
          <md-input v-model="form.positionx" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label>Y</label>
          <md-input v-model="form.positiony" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-25">
        <md-field>
          <label>Z</label>
          <md-input v-model="form.positionz" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
    </div>

    <div class="md-layout" v-if="form.templateId === 'MoveCamera'">
      <div class="md-layout-item md-size-15" style="padding-left: 0px; padding-top: 20px">
        <label class="md-form-label-ext"> 角度 * </label>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label>X</label>
          <md-input v-model="form.anglex" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label>Y</label>
          <md-input v-model="form.angley" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-25">
        <md-field>
          <label>Z</label>
          <md-input v-model="form.anglez" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
    </div>

    <md-field v-if="form.templateId === 'MoveCamera'">
      <label>移动方式 *</label>
      <md-select v-model="form.moveType" name="moveType" :disabled="disabled">
        <md-option value="sy">瞬移</md-option>
        <md-option value="py">平移</md-option>
      </md-select>
    </md-field>

    <md-field v-if="form.templateId === 'MoveCamera' || form.moveType === 'py'">
      <label>时间 *</label>
      <md-input v-model="form.pyTime" type="number" :disabled="disabled"> </md-input>
    </md-field>

  </div>
</template>

<script>
let dict = {}
dict['OpenUI'] = '打开UI'
dict['CloseUI'] = '关闭UI'
dict['PlayVideo'] = '打开视频'
dict['PlayAudio'] = '播放音频'
dict['Delay'] = '延时'
dict['MoveCamera'] = '移动摄像机'
export default {
  data() {
    return {
      form: {},
      actionMap: {},
      list: [],
      disabled: false,
    }
  },
  watch: {
    'form.templateId'(val) {
      this.form.templateName = dict[val]
    }
  },
  methods: {
    init(form) {
      this.form = form
    }
  }
}
</script>